export const AUDIO_TYPES = [
  { display_name: "FM/AM Broadcast",          id: "477", type: "inventory_type", value: "2", clusivity: "include" },
  { display_name: "Music Streaming Service",  id: "476", type: "inventory_type", value: "1", clusivity: "include" },
  { display_name: "Podcasts",                 id: "528", type: "inventory_type", value: "3", clusivity: "include" },
  { display_name: "Text To Speech Articles",  id: "479", type: "inventory_type", value: "7", clusivity: "include" },
];

// `creatives.audio_types` is a Postgres `text[]` column, so PostgREST returns
// each element as a JSON string. Mirror the cycle-scheduled-tasks parsing
// (`json.loads(t) if isinstance(t, str) else t`) so a specific inventory-type
// selection is not silently dropped and rendered as "All Types".
export function parseAudioTypes(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((entry) => {
      if (entry && typeof entry === "object") return entry;
      if (typeof entry === "string") {
        try {
          const parsed = JSON.parse(entry);
          return parsed && typeof parsed === "object" ? parsed : null;
        } catch {
          return null;
        }
      }
      return null;
    })
    .filter(Boolean);
}
